"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var CheckoutForm_1 = __importDefault(require("../../Components/CheckoutForm"));
var reconnect_js_1 = require("reconnect.js");
var NavUrl_1 = __importStar(require("../../Utils/NavUrl"));
var CheckoutPageWrapper_1 = __importDefault(require("../../Components/CheckoutPageWrapper"));
var CheckoutSummary_1 = __importDefault(require("../../Components/CheckoutSummary"));
function CheckoutInfoPage(props) {
  var _a = props.stickyTop,
    clientStickyTop = _a === void 0 ? null : _a;
  var cart = (0, reconnect_js_1.useOutlet)('cart')[0];
  var AppActions = (0, reconnect_js_1.useOutlet)('actions')[0];
  var _b = props.pageContext.pageId,
    pageId = _b === void 0 ? 'rev-CheckoutInfoPage' : _b,
    _c = props.mobileApp,
    mobileApp = _c === void 0 ? false : _c,
    _d = props.enableInvoiceFeature,
    enableInvoiceFeature = _d === void 0 ? false : _d,
    _e = props.checkoutSummaryProps,
    checkoutSummaryProps = _e === void 0 ? {} : _e,
    restProps = __rest(props, ["pageContext", "mobileApp", "enableInvoiceFeature", "checkoutSummaryProps"]);
  var _f = react_1.default.useState(clientStickyTop),
    stickyTop = _f[0],
    setStickyTop = _f[1];
  var sideElemRef = react_1.default.useRef(null);
  var checkoutFormRef = react_1.default.useRef(null);
  react_1.default.useLayoutEffect(function () {
    if (sideElemRef.current && clientStickyTop === null) {
      var top_1 = sideElemRef.current.getBoundingClientRect().top;
      console.log('get stickyTop', top_1);
      setStickyTop(top_1);
    }
  }, [clientStickyTop]);
  return react_1.default.createElement(Wrapper, {
    id: pageId,
    stickyTop: stickyTop
  }, react_1.default.createElement("div", {
    className: "container"
  }, react_1.default.createElement("div", {
    className: "main"
  }, react_1.default.createElement(CheckoutForm_1.default, __assign({
    ref: checkoutFormRef,
    mobileApp: mobileApp,
    enableInvoiceFeature: enableInvoiceFeature
  }, restProps))), react_1.default.createElement("div", {
    className: "gutter"
  }), react_1.default.createElement("div", {
    className: "side",
    ref: sideElemRef
  }, react_1.default.createElement(CheckoutSummary_1.default, __assign({
    cart: cart,
    disabled: cart.items.length === 0,
    onClick: function () {
      if (checkoutFormRef.current) {
        checkoutFormRef.current.submit();
      }
    },
    onPrevClick: function () {
      AppActions.navigate(NavUrl_1.default.from(NavUrl_1.PredefinedRoute.checkout, {}));
    }
  }, checkoutSummaryProps)))));
}
var Wrapper = (0, styled_components_1.default)(CheckoutPageWrapper_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
exports.default = CheckoutInfoPage;
var templateObject_1;